import Vue from 'vue'
import { formatCurrency } from '@/services/convert'

export default Vue.extend({
  template: `
    <div class="custom-title">
        <span class="custome-header-title">{{ value || value === 0 ? formatCurrency(value) : formatCurrency(0) }}</span>
        <span class="custome-header-title" v-if="percentage || percentage === 0">
          ({{ percentage.toFixed(2) }}%)
        </span>
    </div>
`,

  data() {
    return {
      value: undefined,
      percentage: undefined,
      formatCurrency: formatCurrency,
    }
  },

  created() {
    this.value = this.params.data.assetClass[this.params.colDef.field]
    this.percentage = this.params.data.percentage[this.params.colDef.field]
  },
})
